/** 背包物品稀有度（與後端 InventoryConstants::RARITY_MAP 一致） */
export const INVENTORY_RARITY_LABELS = {
    white: '普通',
    green: '優秀',
    blue: '稀有',
    purple: '史詩',
    orange: '傳說',
    red: '神話',
    gold: '唯一'
};

export const INVENTORY_RARITY_COLORS = {
    white: 'default',
    green: 'success',
    blue: 'blue',
    purple: 'purple',
    orange: 'orange',
    red: 'error',
    gold: 'gold'
};

export const rarityLabel = (rarity) =>
    INVENTORY_RARITY_LABELS[rarity] ?? rarity;

export const rarityTagColor = (rarity) =>
    INVENTORY_RARITY_COLORS[rarity] ?? 'default';

/** 展示分類顯示名稱（後端欄位為 display_name，非 name） */
export const itemTypeDisplayName = (record, typeOptions = []) => {
    if (record?.item_type_display) {
        return record.item_type_display;
    }
    if (record?.item_type?.display_name) {
        return record.item_type.display_name;
    }
    if (record?.item_type_id && typeOptions.length) {
        const opt = typeOptions.find((o) => o.value === record.item_type_id);
        return opt?.label ?? null;
    }
    return null;
};
